module.exports = __webpack_public_path__ + "static/media/dem_wre_bal.1cd156cf.png";